export const symptomsDataAdult = [
    {
      symptom: 'Ketombe',
      pepOil:
        'Lavender , Lemon, Peppermint  (bisa pilih atau dicampur) Cara 1. 1-2 tetes, massage di kulit kepala 30 menit sblm keramas, lalu keramas spt biasa. Cara 2. 1-2 tetes di shampoo, diamkan 1-3 menit di kulit kepala yg sdh basah, keramas spt biasa. ',
      nonPepOil:
        'Rosemary, Wintergreen, Tea Tree, Cedarwood, Cypress. Cara 1&2 idem.',
      blend:
        'Blend 1. Dalam botol spray 30 ml :  + 5 Lemon + 3 Lavender + 3 Rosemary + 3 Tea Tree. Tambahkan air minum atau witch hazel hingga penuh. Spray 2x sehari di kulit kepala.',
      supplement: 'Sulfurzyme',
      personalCare:
        'Pilih Shampoo senatural mungkin (minimal sintetiks) Gunakan Seedling Shampoo',
    },
    {
      symptom: 'Rambut rontok',
      pepOil:
        'Lavender , Lemon, Peppermint  (bisa pilih atau dicampur) Cara 1. 1-2 tetes, massage di kulit kepala 30 menit sblm keramas, lalu keramas spt biasa. Cara 2. 1-2 tetes di shampoo, diamkan 1-3 menit di kulit kepala yg sdh basah, keramas spt biasa. ',
      nonPepOil:
        'Rosemary, Cedarwood, Thyme, Ylang-Ylang, Clary Sage. Cara 1&2 idem.',
      blend:
        'Blend 1. Dalam botol spray 30 ml :  +  5 Lavender + 5 Rosemary +  3 Thyme. Tambahkan air minum atau witch hazel hingga penuh. Spray 2x sehari di kulit kepala.',
      supplement: 'Sulfurzyme',
      personalCare:
        'Pilih Shampoo senatural mungkin (minimal sintetiks) Gunakan Seedling Shampoo',
    },
    {
      symptom: 'Rambut pitak',
      pepOil:
        'Lavender. Cara : oles langsung di area pitak, 1x/hari. Dilute bila perlu atau area luas.',
      nonPepOil: 'Thyme, Rosemary, Cedarwood. Cara : idem',
      blend:
        'Blend 1 : Dalam botol dropper 5 ml : + 2 Cedarwood + 3 Lavender + 2 Thyme + 3 Rosemary. Top up dgn Mirah Hair Oil, atau Tamanu Oil. Oles 2x sehari di area pitak.',
      supplement: 'Sulfurzyme',
      personalCare:
        'Pilih Shampoo senatural mungkin (minimal sintetiks) Gunakan Seedling Shampoo',
    },
    {
      symptom: 'Rambut beruban',
      pepOil:
        'Lavender, Frankincense. Cara: 1 tetes di shampoo natural di tangan, lakukan setiap keramas.',
      nonPepOil:
        'Rosemary, Sandalwood, Clary Sage, (Thyme +carrier oil), Ginger, Black Seed. Cara: Alternatif bikin Hair Serum. 5ml Black seed oil, 5 tetes EO pilihan, pake roll on, langsung oles di kulit kepala di malam hari, esok pagi keramas.',
      blend:
        '15ml botol kaca spray: isi 7 tetes lavender, 7 tetes rosemary, semprot ke  kulit dan batang rambut.',
      supplement: 'NingXia Red, Sulfurzyme, Omegagize',
      personalCare:
        'Pilih Shampoo senatural mungkin (minimal sintetiks) Gunakan Seedling Shampoo',
    },
    {
      symptom: 'Kulit keriput (wrinkle)',
      pepOil:
        'Frankincense, Lavender, Copaiba. Cara 1: Buat Face Serum. Botol 5ml diisi 3/4 dengan carrier oil yang sesuai dengan kondisi kulit (misal: avocado oil / argan oil), Lalu teteskan EO masing-masing 2-3 tetes. Gunakan pagi dan malam di kulit yang sudah bersih. Cara 2: Teteskan 1 tetes masing-masing ke serum muka yang dimiliki di tangan. Gunakan pagi malam',
      nonPepOil: 'Patchouli, Carrot Seed, Helichrysum, Geranium. Cara 1 & 2 sama',
      blend:
        '15 ml botol isi dengan Helichryum (3), Geranium (3), Lavnder (3), Frankincense (3), tambahkan di Carrier oil yang cocok dengan kondisi kulit (avocado oil, argan oil, dst) hingga 3/4 botol (tidak perlu penuh menghindari tumpah).',
      supplement: 'NingXia Red, Sulfurzyme, Omegagize',
      personalCare: 'Gunakan Bloom Essence sebagai serum muka',
    },
    {
      symptom: 'Jerawat',
      pepOil:
        'Lavender, Frankincense, Lemon, Purification, Copaiba. Cara: Jerawat besar, bisa langsung pilih 1 oil dan ditotol di lokasi jerawat dengan tangan bersih. Ambil oil dari pinggir leher botol, jangan dari bolongan tengah botol (jadi ambil sedikit saja), atau gunakan cotton bud.',
      nonPepOil: 'Tea Tree, Kunzea, Melrose. Cara sama.',
      blend:
        '5ml botol teteskan Melaleuca (3), Lavender (3), Copaiba (3), Frankincense (3), tambahkan Carrier oil yang cocok dengan kondisi kulit (avocado oil, argan oil, dst) hingga 3/4 botol (tidak perlu penuh menghindari tumpah).',
      supplement: 'NingXia Red, Sulfurzyme, Omegagize',
      personalCare:
        'Gunakan Bloom Series untuk Facial Wash, Essence dan Lotion. Untuk jerawat kecil-kecil (baik muka dan punggung) bisa gunakan Charcoal Bar Soap.',
    },
    {
      symptom: 'Flek hitam (dark spot)',
      pepOil:
        'Lavender, Lemon, Frankincence, Copaiba. Cara 1: Pilih salah satu dan teteskan kedalam serum muka yang digunakan pagi dan malam.  Cara 2: Bikin sendiri Face Serum (cek DIY)',
      nonPepOil: 'Helichrysum, myyrh. Cara sama.',
      blend:
        '5ml botol teteskan (3) Helichrysum, (3) Frankincense, (3) Copaiba, tambahkan Carrier oil yang cocok dengan kondisi kulit (Avocado oil, argan oil, dst) hingga 3/4 botol (tidak perlu penuh menghindari tumpah).',
      supplement: 'NingXia Red, Sulfurzyme, Omegagize',
      personalCare: 'Gunakan Bloom Series untuk Facial Wash, Essence dan Lotion.',
    },
    {
      symptom: 'Mata lelah',
      pepOil:
        'Frankincense. Cara: Eye cupping. Teteskan 1 tetes ke telapak tangan, gosok dengan kedua tangan. Tutup mata dengan tangan membuat posisi seperti tenda. Lalu buka mata dan lirik mata ke kanan kiri atas bawah. Biarkan uap nya terkena mata (agak perih sedikit)',
      nonPepOil: 'Carrot Seed, Lemongrass, Cypress. Cara sama.',
      blend:
        '5ml botol teteskan (3) Cypress, (3) Lemongrass (3) Frankincense, tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area mengelilingi mata.',
      supplement: 'Ningxia Red, Illumineyes',
      personalCare: 'Not available',
    },
    {
      symptom: 'Mata merah',
      pepOil:
        'Frankincense. Cara: Eye cupping. Teteskan 1 tetes ke telapak tangan, gosok dengan kedua tangan. Tutup mata dengan tangan membuat posisi seperti tenda. Lalu buka mata dan lirik mata ke kanan kiri atas bawah. Biarkan uap nya terkena mata (agak perih sedikit).',
      nonPepOil: 'Myrrh, Sacred Frankincence. Cara sama.',
      blend:
        '5ml botol teteskan (3) Copaiba (3) Lavender (3) Frankincense, tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area mengelilingi mata.',
      supplement: 'Illumineyes (sesuai dosis).',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit kepala',
      pepOil:
        'Peppermint, Panaway, Frankincense, Lavender. Oles salah satu oil di area sakit kepala & sekitarnya. Ulangi sering sesuai kebutuhan. Dilute bila perlu.',
      nonPepOil: 'Aroma Seiz, Deep Relief, Relieve It. Cara sama.',
      blend:
        '5ml botol teteskan (3) Peppermint (3) Panaway (3) Lavender, tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area sesuai kebutuhan.',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Migraine',
      pepOil:
        'Peppermint, Panaway, Lavender. Oles salah satu oil di area migraine. Ulangi sering sesuai kebutuhan. Dilute bila perlu.',
      nonPepOil: 'M-Grain, Basil, Eucalyptus, Panaway, Deep Relief. Cara sama.',
      blend:
        '5ml botol teteskan (3) Peppermint (3) Panaway (3) Lavender, tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area sesuai kebutuhan.',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sulit tidur (insomnia)',
      pepOil:
        'Lavender, Stress away. 1. Diffuse salah satu oil @5 tetes. 2. Diffuse ke-2 oil @3 tetes. 3. Hand cupping : 1 tetes oil di telapak tangan, gosok di ke-2 telapak tangan, buat tenda menutup hidung dan hirup 5-15 menit.',
      nonPepOil:
        'Cedarwood, Vetiver, Rutavala, Bergamot, Citrus Fresh, Peace & Calming. Cara sama.',
      blend:
        '5ml botol teteskan (5) Lavender (5) Stress away (3) Lavender, tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area kepala sesuai kebutuhan.',
      supplement: 'Sleep Essence (sesuai dosis).',
      personalCare: 'Not available',
    },
    {
      symptom: 'Konsentrasi',
      pepOil:
        'Peppermint, Lemon : 1. Diffuse tiap oil @3 tetes. 2. Inhaler tiap oil @3-5 tetes, hirup bergantian ke2 lubang hidung @1-2 menit, selama total 5-15 menit.',
      nonPepOil: 'Rosemary, Cedarwood, Basil, Lavender, Scent Wise. Cara sama.',
      blend:
        '5ml botol teteskan (3) Peppermint (3) Lemon (3) Rosemary tambahkan Carrier oil secukupnya, tutup dengan aromaglide roller (atau gunakan botol roll on). Oleskan ke area sesuai kebutuhan.',
      supplement: 'Mind Wise (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit otot (pegal)',
      pepOil:
        'Lavender, Panaway, Peppermint. Oleskan pada bagian yang sakit. Dilute sesuai kebutuhan.',
      nonPepOil:
        'Marjoram, Idaho Grand Fir, Cypress, Kunzea, Deep Relief, Relieve It, Wintergreen, Rosemary. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      blend:
        'Pine (5) + Rosemary (4) + Ginger (4) + Vetiver (2) + V6 di botol 10 ml, oles di bagian yang sakit.',
      supplement: 'Agilease, BLM (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit otot (kram)',
      pepOil:
        'Lavender, Panaway, Peppermint. Oleskan pada bagian yang sakit. Dilute sesuai kebutuhan.',
      nonPepOil:
        'Marjoram, Idaho Grand Fir, Cypress, Kunzea, Deep Relief, Relieve It, Wintergreen, Rosemary. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      blend:
        'Peppermint (10) + Panaway (10) + Valor (10) + Lavender (5) + V6 di botol 15 ml, oles di bagian yang sakit.',
      supplement: 'Agilease, BLM (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit pinggang',
      pepOil:
        'Lavender, Panaway, Peppermint. Oleskan pada bagian yang sakit. Dilute sesuai kebutuhan.',
      nonPepOil:
        'Marjoram, Idaho Grand Fir, Cypress, Kunzea, Deep Relief, Relieve It, Wintergreen, Rosemary. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      blend:
        'Pine (5) + Rosemary (4) + Ginger (4) + Vetiver (2) + V6 di botol 10 ml, oles di bagian yang sakit.',
      supplement: 'Agilease, BLM (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Keseleo (terkilir)',
      pepOil:
        'Copaiba, Lavender, Panaway, Peppermint. Oleskan pada bagian yang sakit. Dilute sesuai kebutuhan.',
      nonPepOil:
        'Marjoram, Idaho Grand Fir, Cypress, Kunzea, Deep Relief, Relieve It, Wintergreen, Rosemary. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      blend:
        'Lavender (3) + Marjoram (3) + Cypress (3) + Peppermint (5) + V6 di botol 10 ml, oles di bagian yang sakit',
      supplement: 'Agilease, BLM (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit pada sendi (arthritis)',
      pepOil:
        'Copaiba, Frankincense, Lavender, Peppermint. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      nonPepOil:
        'Rosemary, Marjoram, Cypress, Wintergreen, Kunzea, Idaho Grand Fir. Oles pada bagian yang sakit. Dilute sesuai kebutuhan.',
      blend:
        'Lavender (3) + Marjoram (3) + Cypress (3) + Peppermint (5) + V6 di botol 10 ml, oles di bagian yang sakit',
      supplement: 'Agilease, BLM, Sulfurzyme (sesuai dosis)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Flu',
      pepOil:
        'Peppermint - Lavender - Lemon : untuk difuse bisa dicampurkan dengan perbandingan 1:1, total 6 -8 tetes, di oles kan pada dada, leher atau telapak kaki, dilute sesuai kebutuhan, bisa dicampurkan ke dalam inhaler dengan perbandingan 1:1 total 6 - 8 tetes. Thieves : diffuse atau dioleskan di sepanjang spine atau di telapak kaki, dilute sesuai kebutuhan.  RC : difuse, di teteskan pada inhaler atau di oleskan di dada atau leher.',
      nonPepOil:
        'Thyme, Eucalyptus, Teatree : Diffuse atau di oleskan di telapak kaki dan atau spine, dilute sesuai kebutuhan.',
      blend:
        'Lavender (3) + Marjoram (3) + Cypress (3) + Peppermint (5) + V6 di botol 10 ml, oles di bagian yang sakit',
      supplement: 'Innerdefense, ImmuPro',
      personalCare: 'Not available',
    },
    {
      symptom: 'Batuk',
      pepOil:
        'RC, Lemon, Frankincense, Thieves. 1. Diffuse salah satu oil @5 tetes. 2. Diffuse ke-2 oil @3 tetes. 3. Hand cupping : 1 tetes oil di telapak tangan, gosok di ke-2 telapak tangan, buat tenda menutup hidung dan hirup 5-15 menit.  4. Oleskan di leher (dilute sesuai kebutuhan)',
      nonPepOil: 'Eucalyptus, Breathe Again',
      blend:
        'Campurkan thieves 1 - 2 tetes ke 1/2 gelas air minum, kemudian gargle.',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit perut',
      pepOil:
        'Digize, Aromaease, Peppermint pilih salah satu oil oles di pinggang, perut yang sakit dan perut bagian bawah. Dilute sesuai keperluan.',
      nonPepOil: 'Ginger, Fennel',
      blend: 'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Diare',
      pepOil: 'Peppermint, Digize',
      nonPepOil:
        'Ginger, Fennel pilih salah satu oil oles di pinggang, perut yang sakit dan perut bagian bawah. Dilute sesuai keperluan.',
      blend: 'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'PMS',
      pepOil: 'Lavender',
      nonPepOil: 'Clary Sage, Fennel, Bergamot, Peace & Calming',
      blend: 'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sembelit (susah BAB/konstipasi)',
      pepOil:
        'Digize, lemon. Cara 1: oles di perut searah jarum jam mengitari belly button. Cara 2: minum 2 tetes lemon di kapsul malam sebelum tidur.',
      nonPepOil: 'Lemongrass, ginger. cara sama.',
      blend:
        'Lemon (10) + Digize (10) + V6 di botol roller 10 ml, oles di perut searah jarum jam.',
      supplement: 'Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'GERD',
      pepOil:
        'Peppermint, Digize, Aromaease. Cara 1: oles di perut dan ulu hati. Cara 2: Digize 3 tetes di kapsul, langsung minum ketika dirasa gejala2 GERD akan muncul (agar efek terasa lebih cepat).',
      nonPepOil: 'Lemongrass, ginger, fennel: sama dengan cara 1',
      blend:
        'Digize (10) + Peppermint (10) + Lemongrass (10) + V6 di botol roller 10ml, oles di perut dan ulu hati.',
      supplement: 'Ningxia Red, Alkalime, Life 9',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit maag (asam lambung)',
      pepOil:
        'Peppermint, Digize, Aromaease. Cara 1: oles di perut dan ulu hati. Cara 2: Digize 3 tetes di kapsul, langsung minum ketika dirasa gejala2 maag akan muncul (agar efek terasa lebih cepat).',
      nonPepOil: 'Lemongrass, ginger, fennel  : sama dengan cara 1',
      blend:
        'Digize (10) + Peppermint (10) + Lemongrass (10) + V6 di botol roller 10ml, oles di perut dan ulu hati.',
      supplement: 'Ningxia Red, Alkalime',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit perut (menstruasi)',
      pepOil:
        'Lavender, Peppermint, aromaease. oles di pinggang, perut yang sakit dan perut bagian bawah.',
      nonPepOil:
        'Clarysage + Basil, Dragon Time, Endoflex, Deep Relief, Cool Azul. Cara oles sama. Dragon time bisa dioles seminggu sebelum mens datang.',
      blend:
        'DragonTime 10 + Basil 4 taro di roller, oles di  mata kaki, pinggang belakang dan perut bawah',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Mens tidak teratur',
      pepOil:
        'Peppermint, Lavender, Frankincense. oles di mata kaki sebelah kanan secara rutin. Oles Frankincense di bagian kulit yang tipis (Lengan bagian dalam, leher)',
      nonPepOil:
        'Clarysage, Rosemary, PPP : oles rutin di bagian kulit yang tipis (seperti lengan bagian dalam, leher), oles di mata kaki sebelah kanan.',
      blend:
        'Clary sage (10) + Rosemary (5) + V6 di botol roller 5ml, oles di bagian kulit yg tipis (lengan bagian dalam, leher), oles di mata kaki sebelah kanan',
      supplement: 'Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Mata bintitan',
      pepOil: 'Frankincense, lavender, Copaiba (Handcupping mata secara rutin).',
      nonPepOil: 'Sacred Frankincense (Handcupping mata secara rutin).',
      blend:
        '1 Frankicence/Sacred Frankincense, 1 copaiba (Handcupping mata secara rutin).',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Panic attack',
      pepOil:
        'Lavender, Frankincense, Lemon, Copaiba (Tetes diubun2, oles di dada, oles di root cakra/solar plexus  dan handcupping lalu hirup dalam2).',
      nonPepOil:
        'Harmony, Idaho Blue Spruce, Sacred Frankincense Cedarwood, White Angelica, Peace and Calming, Valor, Orange (Tetes diubun2, oles di dada, oles di root cakra/solar plexus  dan handcupping lalu hirup dalam2).',
      blend:
        '2 Frankincense, 2 Copaiba, 2 Whiteangelica, 1 Cedarwood (Tetes diubun2, oles di dada, oles di root cakra/solar plexus  dan handcupping lalu hirup dalam2).',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Grief (rasa duka)',
      pepOil:
        'Frankincense, Stressaway, Lavender, Aromaease (Difuse, handcupping, oles di heart cakra).',
      nonPepOil:
        'Joy, Bergamot, Palo Santo, Roman Chamomile, Forgiveness, Gentle Baby, Release, Sacred Mountain, Valor, Vetiver, Present time (Difuse, handcupping, oles di heart cakra).',
      blend:
        'Bergamot 1 + Frankincense 1 + Vetiver 1 , oles di belakang leher dan dada, kemudian hirup dalam.',
      supplement: 'Cortisol',
      personalCare: 'Not available',
    },
    {
      symptom: 'Kulit memar (lebam)',
      pepOil:
        'Lavender, Copaiba, Panaway, Peppermint,  (oles di memar segera mungkin).',
      nonPepOil:
        'Helicrycum (paling efektif neat di memar segera mungkin), Geranium (apply setelah , Clove, Cistus, Cypress, Roman Chamomile, Marjoram, Kidscent Care (oles di memar segera mungkin).',
      blend:
        'Blend 1: 5 Helichrysum, 4 lavender, 3 Cypress, 3 Cistus, 3 Geranium. Blend 2: 6 clove, 4 black pepper, 3 peppermint, 2 marjoram, 2 geranium, 2 cypress',
      supplement: 'Super C, Multgreen, Juvatone, Juvapower, Ningxia Red',
      personalCare:
        'Cool Azul Pain Relief Cream, Cool Azul Sport Gel, Ortho Sport Masssage Oil, Orthoease Massage Oil',
    },
    {
      symptom: 'Cantengan',
      pepOil:
        'Lavender, Frankincense, Lemon, Purification, Digize (oles/tetes di kuku).',
      nonPepOil:
        'TeaTree, Wintergreen, Myrrh, Sacred Frankincense, Idaho Balsam Fir (oles/tetes di kuku).',
      blend:
        '2 Frankincense/Sacred Frankincence, 2 Myrrh, 2 Lemon, 1 Wintergreen (oles/tetes di kuku).',
      supplement: 'Sulfurzyme, Megacal, Master formula',
      personalCare: 'Not available',
    },
    {
      symptom: 'Luka/Lecet',
      pepOil: 'Lavender, Copaiba (oles neat di luka atau cold compress).',
      nonPepOil:
        'Helichrysum, Geranium, Cypress, Cistus, Myrrh, Deep relief (oles neat di luka atau cold compress)',
      blend:
        '3 helichrysum, 2 copaiba, 2 geranium, 2 lavender (oles neat di luka atau cold compress)',
      supplement: 'Not available',
      personalCare: 'Baby Lotion',
    },
    {
      symptom: 'Keputihan',
      pepOil: 'Lavender (1-2 tetes di pakaian dalam).',
      nonPepOil:
        'TeaTre, Myrrh, Mountain Savory, Melissa, Melrose, Thieves (oral atau tetes di pakaian dalam).',
      blend: '7 tea tree, 5 mountain savory, 2 myrrh (oral).',
      supplement:
        'ICP (pagi), Juvapower (mlm), Comfortone, Detoxzyme, Life 9 (60 days).',
      personalCare: 'Claraderm',
    },
    {
      symptom: 'Kulit kering/pecah-pecah',
      pepOil:
        'Lavender, Lemon, Frankincence, Copaiba. Cara: Pilih salah satu dan teteskan ke dalam lotion.',
      nonPepOil:
        'Geranium, Gentle Baby, Myrrh, Elemi, Patchouli. Cara: Pilih salah satu dan teteskan ke dalam lotion.',
      blend: 'Not available',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Gatal karena digigit binatang',
      pepOil:
        'Peppermint, Lavender, Lemon, Purification (oles di bagian yang gatal).',
      nonPepOil: 'Tea Tree (oles di bagian yang gatal).',
      blend: 'Not available',
      supplement: 'Not available',
      personalCare: 'Outdoor blend, Baby Lotion',
    },
    {
      symptom: 'Gatal karena alergi',
      pepOil:
        'Peppermint, Lavender, Lemon, Purification (oles di bagian yang gatal).',
      nonPepOil: 'Tea Tree (oles di bagian yang gatal).',
      blend: '1 lavender, 1 lemon, 1 peppermint (oles di bagian yang gatal).',
      supplement: 'Sulfurzyme',
      personalCare: 'Not available',
    },
    {
      symptom: 'Kolesterol',
      pepOil:
        'Lavender, cara: oles di titik vita flex, di dada daerah jantung, dan sepanjang lengan, 2-4 tetes, 2-3 kali sehari, dilute bila perlu.',
      nonPepOil:
        'Lemongrass, Helicrycum, Rosemary, Clove, German Chamomile, Aroma Life, Longevity, Cara : oles 2-4 tetes di titik denyut (daerah arteri yang dekat dengan kulit seperti pergelangan tangan, siku bagian dalam, leher bawah) oles 2-3 kali sehari. Bisa juga dioles di sepanjang tulang belakang 6-10 tetes, 3 kali sehari. Dilute bila perlu.',
      blend:
        '5 Roman Chamomile + 5 Lemongrass + 4 Rosemary +3  Helicrycum, cara sama dengan oil non PEP.',
      supplement: 'OmegaGize, Juva Tone, slique tea',
      personalCare: 'Not available',
    },
    {
      symptom: 'Asam urat',
      pepOil:
        'Lemon, PanAway, Frankinsence. Cara: Oles di sendi yang sakit 2-3 kali sehari.',
      nonPepOil:
        'Fennel, Wintergreen, Pine, Juniper, Jade lemon, Lime, Idaho Blue spruce, Roman Chamomile, Tea Tree, JuvaCleanse, Cool Azul. Cara: sama dengan oil PEP.',
      blend:
        'Gout Blend : 10 Lemon + 5 Idaho Blue Spruce + 4 Juniper + 3 Tea Tree + 2 Roman Chamomile. Cara: sama',
      supplement:
        'AlkaLime, AgilEase, MultiGreens, ComforTone, Essentialzyme, JuvaPower, JuvaTone.',
      personalCare: 'Not available',
    },
    {
      symptom: 'Diabetes (kencing manis)',
      pepOil:
        'Lavender, Thieves. Cara: oles pada punggung, dada, telapak kaki, dan di atas pankreas 2-3 kali sehari, dilute bila perlu.',
      nonPepOil:
        'Ocotea, Clove, Coriander,Fennel, Dill, Cinamon bark, Lemongrass, Endoflex, DiGize, Slique Essence,TummyGize, Cara oles : sama. Oral ; ocotea dan coriander dalam capsul perbandingan 1:1, diminum 2 kali sehari.',
      blend:
        'Blend #1 :5 cinnamon bark + 5 cypress, Blend #2: 8 Clove + 8 Cinnamon bark + 15 rosemary + 10 Thyme dalam 60 ml V6 oil. Cara : oles di telapak kaki dan area pankreas.',
      supplement:
        'MultiGreens, MegaCal, Essentialzyme, master Formula, Ningxia Wolfberries, Slique Tea.',
      personalCare: 'Not available',
    },
    {
      symptom: 'UTI',
      pepOil:
        'Lemon, Lavender, Thieves, DiGize. Cara : dilute dengan V6 oil dan pijat pada daerah abdomen, pungung bawah, area pubik.',
      nonPepOil:
        'Myrrh, Tea Tree, Oregano, Sage, Juniper, Jade Lemon, Melissa, Rosemary, Melrose, Purification, Endoflex. Cara : #1 sama dengan oil PEP, #2 dilute dan gunakan dalam kompres hangat di area pubik 1-2 kali sehari.',
      blend:
        'Blend #1 sage + purification , Blend #2 Thyme + Melrose, Blend #3 Oregano + Thieves, Blend #4 Juniper + Endoflex. Cara oles sama.',
      supplement: 'ImmuPro, Inner Defense, AlkaLime.',
      personalCare: 'Not available',
    },
    {
      symptom: 'Hipertensi (tekanan darah tinggi)',
      pepOil:
        'Lavender. Cara: oles di titik vitaflex jantung, lengan kiri, tangan, kaki dan di dada area jantung, pelipis dan belakang leher belakang beberapa kali dalam sehari.',
      nonPepOil:
        'Ylang ylang. Cara: teteskan di telapak tangan, gosok kedua telapak tangan, letakan menutupi hidung, bernafas dalam selama 5 menit. dan/atau oles di telapak kaki. Aroma Life, Peace & Calming,Citrus Fresh, Helichrysum, Rosemary, Clove, Marjoram, Cypress, Cinamon Bark. Cara : sama dengan oil PEP.',
      blend:
        'Blend #1: 5 Geranium + 8 Lemongrass + 3 Lavender + 30 ml V6 oil. Blend #2: 10 Ylang Ylang + 5 Marjoram + 5 Cypress + 30 ml V6 Oil. Cara: Oles di area jantung dan titik vitaflex jantung di kaki kiri dan tangan kiri.',
      supplement:
        'Essentialzyme, Detoxzyme, OmegaGize, ImmuPro, Super B, Mineral Essence, MegaCal, Ningxia Wolfberries, MindWise.',
      personalCare: 'Not available',
    },
    {
      symptom: 'Obesitas (kelebihan berat badan)',
      pepOil:
        'Lemon. Cara: oles di perut atau tetes di air putih hangat, minum setelah bangun pagi.',
      nonPepOil: 'cel lite massage oil, grapefruit, citrus fresh',
      blend: 'Not available',
      supplement: 'ningxia red, slique tea',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit kuping (telinga)',
      pepOil:
        'Thieves, Copaiba, Frankincense, panaway.cara: oles di sekitar telinga.',
      nonPepOil: 'Basil, Myrrh, Purification.',
      blend:
        'Oles Helichrysum / Lavender di sekitar kuping. Panaway / peppermint untuk meredakan nyeri',
      supplement: 'ImmuPro, Innerdefense',
      personalCare: 'Not available',
    },
    {
      symptom: 'Vertigo',
      pepOil:
        'Peppermint, Aromaease, Frankincense, panaway. Cara : bisa pilih salah satu oil (atau pakai semuanya secara bergantian), oles di belakang leher, tetes di kepala dan hirup.',
      nonPepOil: 'Deep Relief',
      blend:
        'Oles peppermint dan atau deep relief di kepala & leher. Hirup juga.',
      supplement: 'ningxia red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Tinitus',
      pepOil: 'Peppermint, Lavender. Cara: oles disekitar telinga.',
      nonPepOil: 'Helicrycum, Juniper, Geranium, Rose, Basil, Purification.',
      blend:
        'Oles Helichrysum / Lavender di sekitar kuping. Panaway / peppermint untuk meredakan nyeri.',
      supplement: 'ningxia red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Demam',
      pepOil:
        'Peppermint, Copaiba, thieves, Frankincense. Cara : oles peppermint di telapak kaki (tekan area jempol agak lama)), oles juga di punggung.  Bisa layer juga dengan Thieves atau copaiba. Tetes Frankincense di kepala, untuk mencegah kejang.',
      nonPepOil: 'Eucalyptus Blue, Myrrh, Purification, Juniper.',
      blend:
        'Eucalyptus + Lavender (cold compress), Lemon + Lavender + Peppermint - oles di telapak kaki & punggung.',
      supplement: 'innerdefense, immupro, ningxia red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Kutu rambut',
      pepOil: 'Peppermint',
      nonPepOil: 'Cedarwood',
      blend: 'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Bisul',
      pepOil: 'Thieves / purification / frankincense dioles di area bisul.',
      nonPepOil: 'Tea Tree / thyme dilute dgn v6 (1 : 1) dioles di area bisul.',
      blend:
        'Lavender + tea tree +r oman chamomile + v6 (perbandingan sama), lalu dioles ke area bisul.',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Jamur kuku',
      pepOil: 'Lemon, Frankincense',
      nonPepOil: 'Tea  Tree',
      blend: 'Lime, Oregano, Tea Tree + Vit E (oles di kuku)',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Covid +',
      pepOil: 'Inhaler: RC + lemon @20 drops',
      nonPepOil:
        'Inhaler: lemon + RC + eu glob + ravintsara @10 drops, top up setiap 3 hari',
      blend: 'Raindrop 2-3x per hari',
      supplement:
        'Super B, super D, super C, ningxia, inner defense. omegagize, probiotic.',
      personalCare: 'Gargle thieves mouthwash thieves, thieves hand soap/gel.',
    },
    {
      symptom: 'Kontak erat dengan Covid +',
      pepOil: 'Inhaler: RC + lemon @5 drops',
      nonPepOil: 'Inhaler: eucalyptus 4 + RC 3 + lemon 3',
      blend: 'Raindrop 1x per hari',
      supplement: 'Super B, super D, super C, ningxia, inner defense.',
      personalCare: 'Gargle thieves mouthwash thieves, thieves hand soap/gel.',
    },
    {
      symptom: 'Lepuh (luka bakar)',
      pepOil:
        'Lavender dioles neat sering2 sampai sudah mereda lalu frekuensi dikurangi.',
      nonPepOil:
        'Heli, sering2 dioles sampai mereda, setelah itu dilute dengan V6 (1:4)',
      blend: 'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Post Covid',
      pepOil: 'Inhaler: RC + lemon @5 drops',
      nonPepOil: 'Inhaler: eucalyptus 4 + RC 3 + lemon 3',
      blend: 'Raindrop 1x per minggu',
      supplement: 'Super B, super D, super C, ningxia',
      personalCare: 'Not available',
    },
    {
      symptom: 'Meningkatkan imunitas',
      pepOil:
        'Thieves, Frankinsence, Lemon, Lavender, Tea Tree. Oleskan di telapak kaki dan spine',
      nonPepOil:
        'Oregano, Thyme, Clove, Cinnamon Bark, RDT Oils (Oregano, Thyme, Basil, Cypress, Wintergreen, Marjoram, Aroma Siez, Peppermint). Oleskan di telapak kaki dan spine',
      blend:
        'Blend Oregano, Thyme, Tea Tree, Peppermint and Clove dan dimasukkan di bottle roller untuk di diffuse, oles dan minum dalam kapsul.',
      supplement:
        'Super Vitamin C, ImmuPro, Innerdefense, Master Formula, Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Pre/post vaksin Covid',
      pepOil: 'Thives, RC, Lemon, Peppermint. Oleskan di telapak kaki',
      nonPepOil:
        'Raven, Breathe again, Ravintsara, RDT Oils (Oregano, Thyme, Basil, Cypress, Wintergreen, Marjoram, Aroma Siez, Peppermint). Oleskan di dada, dan diffuse.',
      blend:
        'Teteskan RC, Lemon, Ravintsara, Eucalyptus Globulus ke dalam inhaler dan hirup.',
      supplement: 'Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Hilang penciuman',
      pepOil: 'RC, Lemon, Peppermint. Hirup (nose cuppling)/diffuse.',
      nonPepOil:
        'Raven, Breathe again, Ravintsara. Hirup (nose cuppling)/diffuse.',
      blend:
        'Teteskan RC, Lemon, Ravintsara, Eucalyptus Globulus ke dalam inhaler dan hirup dan teteskan 1-2 tetes dari salah satu oil di atas ke dalam baskom berisi air panas dan hirup.',
      supplement: 'Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Mimisan',
      pepOil:
        'Lavender, Frankinsence. Oles di batang hidung dan di lengan bagian dalam',
      nonPepOil: 'Cypress dioles di lengan bagian dalam.',
      blend: 'Not applicable',
      supplement: 'Ningxia Red',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sariawan',
      pepOil: 'Thieves, Lavender, Copaiba, Purification.',
      nonPepOil:
        'Copaiba, Clove, Melissa, Cypress, Thyme, Thieves Spray, Thieves Mouthwash.',
      blend: 'Blend Thieves, Peppermint and Lemon dimasukkan di bottle spray.',
      supplement: 'Super Vitamin C, Ningxia Red, Alkalime',
      personalCare: 'Not available',
    },
    {
      symptom: 'Promil',
      pepOil: 'Peppermint, Thieves.',
      nonPepOil:
        'PPP, Fennel, Clasry Sage, Sclaressense, Ylang ylang, Geranium, Dragon Time (oles pada perut bagian bawah, lengan bagian dalam).',
      blend: 'Not applicable',
      supplement: 'PD 80/20, Multigreens, Mineral Essense, Supercal, Endogize',
      personalCare: 'Not available',
    },
  ];
  
  export const symptomsDataBaby = [
    {
      symptom: 'Flu',
      pepOil:
        'Lavender, Lemon, RC, Peppermint (dipilih 1-2 oil dan diluted). Oleskan di area dada dan punggung sesering mungkin. 1 sendok teh V6 EO nya sekitar 1-2 tetes sudah cukup. Pilihan diffuse: RC, Thieves, Lavender, Lemon, Peppermint',
      nonPepOil:
        'Kidscent Refresh. Oles di dada dengan V6, diulang sehari minimal 4-6x',
      blend:
        '5ml botol dengan V6 secukupnya, tetes Lavender (2) & Peppermint (2) atau RC (2) & Lemon (2). Oleskan di dada dan punggung sesering mungkin ',
      supplement:
        'KidScents Mightyvites (tablet kunyah), Mightypro (probiotik) diminum sesuai dosis',
      personalCare: 'Not available',
    },
    {
      symptom: 'Batuk',
      pepOil:
        'Lemon, RC, Peppermint, Frankincense (dipilih 1-2 oil dan diluted). Oleskan di area dada dan punggung sesering mungkin. 1 sendok teh V6 EO nya sekitar 1-2 tetes sudah cukup. Pilihan diffuse: RC, Lemon, Peppermint',
      nonPepOil:
        'Kidscent Refresh. Oles di dada dengan V6, diulang sehari minimal 4-6x. ',
      blend:
        '5ml botol dengan V6 secukupnya, tetes Frankincense (2) & Peppermint (2) atau RC (2) & Lemon (2). Oleskan di dada dan punggung sesering mungkin',
      supplement:
        'KidScents Mightyvites (tablet kunyah), Mightypro (probiotik) diminum sesuai dosis',
      personalCare: 'Not available',
    },
    {
      symptom: 'Demam',
      pepOil:
        'Pepermint, Lemon ; cara : dilute sesuai usia anak, oles di telapak kaki dan tulang belakang.',
      nonPepOil:
        'Eucalyptus Blue, Copaiba, Lime, Fennel, Bergamot; Cara : dilute sesuai usia anak, oles ditelapak kaki dan/atau tulang belakang.',
      blend: 'Not applicable',
      supplement: 'Not applicable',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sakit perut',
      pepOil: 'Digize (diluted).',
      nonPepOil:
        'KidScents T-gize, Gentle Baby, oles di bagian perut, diulang setiap 1-2 jam.',
      blend:
        'Digize (1) atau AromaEase (1) + V6 dalam botol 5 ml, oles di bagian perut. Ulangi setiap 1-2 jam.',
      supplement: 'KidScents Mightyzyme (tablet kunyah), diminum sesuai dosis.',
      personalCare: 'Not available',
    },
    {
      symptom: 'Diare',
      pepOil:
        'Digize/lemongrass (salah satu) dilute (1 : 5) oles berlawanan arah jarum jam di area perut, ulang setiap 1-2 jam.',
      nonPepOil:
        'Tgize dilute (1 : 5) oles berlawanan arah jarum jam di area perut, ulang setiap 1-2 jam.',
      blend: 'Not applicable',
      supplement: 'Mightypro (probiotic)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Sembelit (susah BAB/konstipasi)',
      pepOil:
        'Digize, aromaease, peppermint (dilute sesuai usia dan oles searah arah jarum jam di area perut, ulang setiap 1-2 jam).',
      nonPepOil:
        'Ginger, T-gize, lemongrass, fennel (dilute sesuai usia dan oles searah arah jarum jam di area perut, ulang setiap 1-2 jam).',
      blend:
        '1 peppermint  + 1 lemongrass + 1 ginger + 1 fennel (dilute sesuai usia dan oles searah arah jarum jam di area perut, ulang setiap 1-2 jam).',
      supplement: 'Mightypro (probiotic)',
      personalCare: 'Not available',
    },
    {
      symptom: 'Diaper rash (ruam popok)',
      pepOil:
        'Lavender, copaiba, frankincense (dilute sesuai usia dan oles di ruam secara rutin).',
      nonPepOil:
        'Helichrysum, Kidscents kidcare, Geranium (dilute sesuai usia dan oles di ruam secara rutin).',
      blend:
        '3 helichrysum, 2 copaiba, 2 geranium, 2 lavender ( dilute sesuai usia dan oles diruam secara rutin).',
      supplement: 'Not available',
      personalCare: 'Diaper rash cream, Baby Lotion.',
    },
    {
      symptom: 'Colic',
      pepOil:
        'Lavender / Copaiba. Pilih salah satu: lakukan pijat ILU di perut bayi, lakukan setelah selesai mandi atau saat dibutuhkan.',
      nonPepOil:
        'Lavender / Copaiba. Pilih salah satu: lakukan pijat ILU di perut bayi, lakukan setelah mandi atau saat dibutuhkan.',
      blend:
        'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Cranky (rewel)',
      pepOil:
        'Lavender (Diffuse), Digize diluted (oles di perut), Tea Tree (oles di telapak kaki).',
      nonPepOil:
        'KidScents T-gize, KidScents SleepIze, KidScents Refresh, Gentle Baby (diffuse/oles di telapak kaki atau dada).',
      blend:
        'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Mimisan',
      pepOil:
        'Lavender, Frankincense. Oleskan EO di lengan anak bagian atas dalam dekat ketiak dan cara 1: Teteskan di kapas dan tempelkan pada hidung anak. Cara 2: ambil dari leher botol dengan tangan bersih, lalu oleskan di hidung anak (sedikit saja).',
      nonPepOil:
        'Cypress. Cara sama',
      blend:
        'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
    {
      symptom: 'Luka/lecet',
      pepOil:
        'Lavender, copaiba. Tetes langsung di luka yang sudah dibersihkan.',
      nonPepOil:
        'Kidscents kidcare. Tetes langsung di luka yang sudah dibsersihkan.',
      blend:
        'Not applicable',
      supplement: 'Not available',
      personalCare: 'Not available',
    },
  ];